module.exports = __webpack_public_path__ + "assets/img/1_1544.dab526e4.jpg";